// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skill_skill__-7ev1"};